<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Abandoned Cart</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/select-class-vehicle.svg')" />
          </div>
        </div>
      </div>
      <div class="container d-flex flex-row-reverse">
      </div>
      <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
        <div class="in-risk-title-dropdown in-risk-title-dropdown--fix" style="width: max-content;">
          <select style="width: 100% !important;" class="floating-select in-dropdown-per-page" @change="onChange($event)">
            <option value="5">5</option>
            <option value="10" selected>10</option>
            <option value="20">20</option>
          </select>
          <span class="highlight"></span>
          <div class="ib-custom-select"></div>
        </div>
          <table class="claim-listing">
            <tbody>
              <tr v-for="policy in dispalyItems" :key="policy.id">
                <td class="jbl-responsive-td data-img" @click="viewPolicy(policy.id, policy.subclass_id, policy.parent_id, policy.risk_id, policy.provide_information_through)" style="width:100px;">
                  <img class="img-fluid" width="100px;" :src="policy.plan_image" v-if="policy.plan_image != ''" />
                  <img class="img-fluid" width="100px;" :src="policy.product_image" v-if="policy.plan_image == ''" />
                  <div class="position-relative">
                    <img alt="icon" class="img-fluid small-icon" :src="policy.company_logo_path" />
                  </div>
                </td>
                <td class="jbl-table-heading jbl-responsive-td" @click="viewPolicy(policy.id, policy.subclass_id, policy.parent_id, policy.risk_id, policy.provide_information_through, policy.plan_id, policy.paid_amount, policy.currency, policy.category_id)">{{ policy.subclass_name }}
                  <small>{{ policy.product_name }}</small>
                  <small v-if="policy.plan_name != ''" class="ib-card-plan">{{ policy.plan_name }}</small>
                </td>
                <td class="jbl-responsive-td" @click="deletePolicy(policy.id)">
                  <a class="ib-delete-btn del_btn_comprehensive">
                    <span ><img class="img-fluid" :src="require('@/assets/images/delete.svg')"/></span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="policies.length === 0">No Data Found</h2>
          <PaginationComponent v-if="isShowing" @updatePage="changePage" @updatedData="getName"  :chunkSize="chunkSize" :customer_self_policies_filterd="customer_self_policies_filterd" :isShowing="isShowing"/>

        </div>
      </div>
    </div>
</template>
<script>
  import loading from '@/components/Loading/Loading'
  import PaginationComponent from "../../components/PaginationComponent";

  export default {
    name: 'AbandonedCart',
    components: {
      loading,
      PaginationComponent,
    },
    data () {
      return {
        showLoader: true,
        policies: [],
        pageOfItems:{},
        dispalyItems:[],
        currentPage:0,
        name:'',
        isShowing : true,
        customer_self_policies_filterd:{},
        chunkSize: 10,
      };
    },
    created: function () {
      const self = this;
      self.getPolicies()
    },
    methods: {
      onChange(e){
        const self =this;
        self.chunkSize = parseInt(e.target.value);
      },
      getName(name){
        this.dispalyItems = name;
      },
      changePage(value){
        this.currentPage = value;
      },
      async getPolicies() {
        const self = this;
        await axios.get('customer/customer_cart_listing').then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.policies = resp.data.data.policies;
            self.customer_self_policies_filterd =resp.data.data.policies;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' })
          }
        }).catch(function (resp) {
          self.showLoader = false;
          $toast.error('Server Error.', {position: 'top-right'})
        });
      },
      viewPolicy (policyId, subClassId, parentId, risk_id, provide_information_through, plan_id, product_price, currency, category_id) {
        const self = this;
        if(parentId != 0) {
          self.$router.push({ name: 'AbandonedRenew', params: { parentId: parentId, quotationId: policyId, subClassId: subClassId } });
        } else {
          self.$router.push({ name: 'AbandonedAcquisition', params: { quotationId: policyId, subClassId: subClassId, riskId : risk_id, provideInformationThrough : provide_information_through , planId : plan_id, productPrice : product_price, currency : currency  }, query: { 'category_id' : category_id }});
        }
      },
      deletePolicy (policyId) {
        const self = this;
        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            axios.delete('customer/policies/delete?customer_quotation_id='+ policyId).then(function (resp) {
              self.showLoader = false;
              if (resp.data.code == 200) {
                let index = self.policies.findIndex(x => x.id == policyId)
                if (index !== -1) {
                  self.policies.splice(index, 1);
                }
                $toast.success('Deleted Successfully !!!', { position: 'top-right' });
              } else {
                $toast.error(resp.data.message, { position: 'top-right' });
              }
            }).catch(function (error) {
              self.showLoader = false;
              if(error.response) {
                error.response.data.errors.forEach(element => {
                  $toast.error(element.message, { position: 'top-right' });
                });
              } else {
                $toast.error(error.data.message, { position: 'top-right' });
              }
            });
          }
        })
      }
    }
  };
</script>

<style scoped>
/*//Tabel Design Custome*/
.data-row:hover {
  box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  cursor: pointer;
}

.data-row p {
  color :#5b6770;
}

table > tbody > tr, .data-row {
  margin: 10px 0;
  padding: 20px 30.7px 20px 15px;
  border-radius: 10px;
  /*box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);*/
  border: solid 1px #dedada;
  background-color: #ffffff;
}

.data-row .action-area {
  text-align: right;
}

.data-row .action-area i {
  width: 7.9px;
  height: 14.6px;
  color: #5b6770;
}

.data-row .claim-row-sub-heading {
  color: #a9adaf;
}

.data-row .claim-row-sub-desc {
  color: #5b6770;
}

.data-row .status-danger {
  background-color: rgba(30, 203, 16, 0.09);
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  color: #1ecb10;
  letter-spacing: normal;
}

.data-row .status {
  margin: 10px 61.3px 10px 52px;
  padding: 6px 24px;
  border-radius: 6px;
  font-family: "Futura PT";
}

.data-row .claim-row-data {
  font-family: "Futura PT";
  font-size: 17px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 8px;
  letter-spacing: normal;
  text-align: left;
}

.data-row .claim-row-heading {
  font-family: "Futura PT";
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}

table > tbody > tr > th > img,.data-img img {
  width: 79px;
  height: 66px;
  border-radius: 11px;
}
.position-relative .small-icon{
  border-radius: 50%;
  position: absolute;
  width: 25px;
  height: 25px;
  top: -20px;
  /* right: 14px; */
  right: 0px;
}














table.claim-listing {
  width: 100%;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  /* font-size: 14px; */
  border-collapse: separate;
  border-spacing: 0 10px;
}
/* table thead {
  background-color: green;
  color: #fff;
}
table thead td:first-child {
  border-left: 1px solid green;
}
table thead td:last-child {
  border-right: 1px solid green;
} */
table.claim-listing td {
  height: 100px !important;
  vertical-align: middle;
  text-align: center;
  position: relative;
}

@media (max-width:668px){
  table.claim-listing td:not(:first-child) {
    height: 60px !important;
  }
  /* table.claim-listing tbody td:last-child{
    display: none;
  } */
  table.claim-listing tbody td:first-child{
    height: auto !important;
  }
}
/* table td:after {
  content: "";
  width: 1px;
  position: absolute;
  right: 0;
  top: 8px;
  bottom: 8px;
  background-color: #eee;
} */
table.claim-listing td:last-child:after {
  content: none;
}
table.claim-listing tbody td {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

@media (min-width:669px){
  table.claim-listing tbody td:first-child {
    border-left: 1px solid #eee;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  table.claim-listing tbody td:last-child {
    border-right: 1px solid #eee;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  table.claim-listing tbody tr{
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  }
}

/* table tbody tr:hover {
  background-color: darksalmon !important;
} */


/* .jbl-table-heading{
  font-family: "Futura PT Medium";
  font-size: 22px;
  font-weight: 500;
  line-height: 1.32;
  text-align: left !important;
  color: #5b6770;
} */
.jbl-table-heading {
  font-family: "Avenir Medium";
  font-weight: 500;
  text-align: left !important;
  font-size: 19px;
  color: #5b6770;
}

.jbl-table-heading span {
  font-size: 19px;
  font-size: 10px;
  color: #5b6770;
  font-weight: normal !important;
}

.jbl-date-td{
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
}
/* .afdsf {
  width: 85px;
  height: 25px;
  margin: 3px 0 0;
  }
  */

.jbl-date-heading{
  color: #ef7c94 !important;
  font-family: "Avenir Book";
  font-size: 13px;
  text-align: left;
}

.jbl-status-approve{
  font-family: "Futura PT Medium";
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  color: #1ecb10;
  width: 81px;
  height: 28px;
  padding: .5rem 1rem;
  border-radius: 6px;
  background-color: rgba(30, 203, 16, 0.09);
  text-transform: capitalize !important;
}
.jbl-in-process{
  font-family: "Futura PT Medium";
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  color: #d9be24;
  width: 81px;
  height: 28px;
  padding: .5rem 1rem;
  border-radius: 6px;
  background-color: #fbf5d3;
  text-transform: capitalize !important;
}

table.claim-listing .fa-chevron-right{
  padding-right: 2rem;
  color: #5b6770;
}

.jbl-flex-td{
  display: flex;
  flex-direction: column;
}

@media (min-width:668px) and (max-width:992px){
  .jbl-table-heading{
    font-size: 14px;
  }
  .jbl-date-td{
    font-family:"Futura PT Medium";
    font-size: 12px;
  }
  .jbl-status-approve{
    font-family: "Futura PT Medium";
    font-size: 10px;
    text-transform: capitalize !important;
  }
  .jbl-in-process{
    font-size: 10px;
    text-transform: capitalize !important;
  }

  table.claim-listing .fa-chevron-right{
    padding-right: 1rem;
    color: #5b6770;
  }
  /* table.claim-listing img{
    padding-left: 1rem;
    padding-right: 1rem;
  } */
}












.d2c-main-classes{
  background-color: #def3f7;
  border-radius: 31px;
  max-width: fit-content;
  /* padding: 11px 0px; */
  margin: 1px 0 30px;
}

.d2c-class-btn {
  display: inline-block;
  margin-bottom: 0;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  padding: 6px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  height: 61px;
  margin: 0 0 1px;
  /* padding: 18px 20px 16px; */
  border-radius: 31px;
  background-color: #def3f7;
  font-family: "Avenir Medium";
  font-size: 16px;
  font-weight: 500;
  line-height: 1.38;
  color: #4c505d;
  transition: all .3s ease-in;
}
.d2c-class-btn:hover {
  background-color: #049cbd;
  color: white;
}
.d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
  outline: none !important;
  background-color: #049cbd;
  color: white;
}
.d2c-main-classes .d2c-class-btn::after{
  content: '';
  width: 0;
  height: 35px;
  border: solid 1px #049ab3;
  position: relative;
  right: -16px;
}
.d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after{
  content: '';
  border: none !important;
}
.d2c-main-classes button:last-child.d2c-class-btn::after{
  content: '';
  border: none !important;
}


.nex-Page-Link .fa-chevron-right{
  color: #aeccd6 !important;
  font-weight: normal !important;
}

table.claim-listing tbody tr:hover{
    box-shadow: 0 3px 6px 0 #d2cccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/AbandonedCart/Index.vue